export default __webpack_public_path__ + "static/media/shop3.c4f96671.jpg";